import React, {Component} from 'react';
import {
    Text,
    Flex,
    Button,
    DialogTitle,
    ToggleSwitch,
    PriorityIcon,
    Icon
} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {DialogModal} from '../../../_shared/componnets/Dialog/Dialog';
import {getInterfacesList, formMailInterfaces} from '../actions/edi';
import {EdiStore} from '../store/edi';
import {returnFocus, setIsNavigationEnabled} from '../../../_shared/GWTBridge/invoke/genPage';
import {setIsReactPopupOpen} from '../../../_shared/GWTBridge/invoke/netForm';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {showSuccessToast} from '../../../components/Toast/actions/ToastActions';
import {helpPopoverRef} from '../../../_shared/Help/constants';

import {DialogSelect} from './DialogSelect';
import style from '../styles/edi.module.scss';

@observer
export class EDIDialog extends Component<any, any> {
    state = {
        isOpen: false
    };

    helpButtonRef: any = React.createRef();

    showDialog = async () => {
        await getInterfacesList();
        if (EdiStore.common) {
            EdiStore.sendAll = false;
            this.onConfirm();
        } else {
            this.setState({isOpen: true});
            setIsReactPopupOpen(true);
            setIsNavigationEnabled(false);
        }
    };

    onCloseHandler = () => {
        this.setState({isOpen: false});

        setIsReactPopupOpen(false);
        setIsNavigationEnabled(true);
        returnFocus();
    };

    showHelp = () => {
        const {current: ref} = helpPopoverRef;
        const {current: help} = this.helpButtonRef;

        const title = getLocalizedText(texts.EDISendAll);
        const content = getLocalizedText(texts.EDISendAllHelp);

        ref.showHelpPopover({title, content, anchor: help});
    };

    renderDialogContent = () => {
        return <DialogSelect />;
    };

    onConfirm = () => {
        formMailInterfaces().then(() => {
            showSuccessToast(getLocalizedText(texts.SendFinish));
        });

        this.setState({isOpen: false});

        setIsReactPopupOpen(false);
        setIsNavigationEnabled(true);
        returnFocus();
    };

    renderTitle = () => {
        return (
            <DialogTitle title={getLocalizedText(texts.EDIDialogTitle)} textColor="primary-700" />
        );
    };

    renderFooter = () => {
        return (
            <Flex justifyContent="flex-end">
                <Button disabled={!EdiStore.hasSelected} onClick={this.onConfirm}>
                    {getLocalizedText(texts.EDIConfirm)}
                </Button>
                <Flex justifyContent="flex-end">
                    <div className={style.toggle} ref={this.helpButtonRef}>
                        <ToggleSwitch
                            tabIndex={-1}
                            checked={EdiStore.sendAll}
                            onChange={() => {
                                EdiStore.sendAll = !EdiStore.sendAll;
                            }}
                        />
                    </div>
                    <Text textColor="primary-700" skin="caption-1">
                        {getLocalizedText(texts.EDISendAll)}
                    </Text>
                    <Button
                        onClick={this.showHelp}
                        prefixIcon={
                            <Icon icon={PriorityIcon.questionCircle} iconColor="primary-700" />
                        }
                        size="small"
                        skin="text"
                        name="help"
                    />
                </Flex>
            </Flex>
        );
    };

    render() {
        const {isOpen} = this.state;
        if (isOpen) {
            return (
                <DialogModal
                    isDialogOpen={isOpen}
                    content={this.renderDialogContent()}
                    onClose={this.onCloseHandler}
                    title={this.renderTitle()}
                    footer={this.renderFooter()}
                    width={718}
                    size={'large'}
                />
            );
        } else {
            return null;
        }
    }
}
